import express, { Request, Response } from "express"
import cors from "cors"

import { getBasePhotoPath } from "#functions/isLinuxServer"

// import { routeGetAllAirPumps, routeGetOneAirPump } from "./routes/airPumps";
// import routeMenu from "./routes/menu/index";
import { routeAuthPost } from "#routes/auth"
import { routeGetCategories } from "#routes/categories"
import { routeGetRecipes } from "#routes/recipes"
import { getRecipeTime, updateRecipeTime } from "#routes/recipe/time"
import { getRecipeInstructions, addRecipeInstructions, updateRecipeInstructions } from "#routes/recipe/instructions"
import { getRecipeIngredients, addRecipeIngredients, updateRecipeIngredients } from "#routes/recipe/ingredients"
import { getRecipeGeneral, updateRecipeGeneral } from "#routes/recipe/general"
import { getRecipePreheat, updateRecipePreheat } from "#routes/recipe/preheat"
import { getRecipePhotos } from "#routes/recipe/photos"

const app = express()
const portnum = 5555

// has to come before everything else
app.use(express())
if (!process.env.recipes_db_socket_path) {
	console.log(`Using host: localhost with CORS via Express`)
	app.use(cors())
}

// reference data lists
app.post("/auth", routeAuthPost)
app.get("/categories", routeGetCategories)

// list
app.get("/recipes/:categoryID", routeGetRecipes)

// details
app.get("/recipe/:recipeID/time", getRecipeTime)
app.put("/recipe/:recipeID/time", updateRecipeTime)
app.get("/recipe/:recipeID/instructions", getRecipeInstructions)
app.post("/recipe/:recipeID/instructions", addRecipeInstructions)
app.put("/recipe/:recipeID/instructions", updateRecipeInstructions)
app.get("/recipe/:recipeID/ingredients", getRecipeIngredients)
app.post("/recipe/:recipeID/ingredients", addRecipeIngredients)
app.put("/recipe/:recipeID/ingredients", updateRecipeIngredients)
app.get("/recipe/:recipeID/general", getRecipeGeneral)
// app.post("/recipe/:recipeID/general", addRecipeIngredients)
app.put("/recipe/:recipeID/general", updateRecipeGeneral)
app.get("/recipe/:recipeID/preheat", getRecipePreheat)
// app.post("/recipe/:recipeID/preheat", addRecipeIngredients)
app.put("/recipe/:recipeID/preheat", updateRecipePreheat)
app.get("/recipe/:recipeID/photos", getRecipePhotos)
// app.post("/recipe/:recipeID/ingredients", addRecipeIngredients)
// app.put("/recipe/:recipeID/ingredients", updateRecipeIngredients)

// static routing
app.use("/static/photos", express.static(getBasePhotoPath()))

// error handling
app.use((err: any, _req: Request, res: Response, _next: () => void) => {
	const statusCode = err.statusCode || 500

	console.error(err.message, err.stack)

	res.status(statusCode).json({ message: err.message })

	return
})

// start the server
app.listen(portnum, (err: any) => {
	console.log(
		`BRANDYS RECIPES API is listening on port: ${portnum}!\n\nStatic photo path is at ${getBasePhotoPath()}\n\n`,
	)

	if (err) {
		console.log(err)
	}
})

// import categories from "./routes/categories";
// import ingredients from "./routes/ingredients";
// import ingredientTypes from "./routes/ingredientTypes";
// import quantities from "./routes/quantities";
// import recipe from "./routes/recipe/index";
// import recipes from "./routes/recipes/index";
// import users from "./routes/user/index";

// import { getBasePhotoPath } from "./functions/isLinuxServer";

// // reading from .env files for parameters
// dotenv.config();

// // bail if port not defined
// const PORT: number = parseInt(process.env.PORT as string, 10);
// if (!process.env.PORT) {
// 	process.exit(1);
// }

// // create new server
// const app = express();

// // security (response headers)
// app.use(helmet());

// // CORS protection
// app.use(cors());

// // JSON format returns
// app.use(expresson());

// // localized debugging for development only
// app.use("*", debug);

// // same alphabetical ordering as above
// app.use("/api/categories", categories);
// app.use("/api/ingredients", ingredients);
// app.use("/api/ingredientTypes", ingredientTypes);
// app.use("/api/quantities", quantities);
// app.use("/api/recipe", recipe); // single
// app.use("/api/recipes", recipes); // multiple
// app.use("/api/users", users);
// app.use("/static/photos", express.static(getBasePhotoPath()));

// // make everything available
// app.listen(PORT, () => {
// 	console.log(`\nListening on port ${PORT}\n\nStatic photo path is at ${getBasePhotoPath()}\n\n`);
// });
